export const DEFAULT_INPUT_PLACEHOLDER = 'Search here';
